// This is the version of the game that is used to identify the game.
// If we want to do a major update, we can increment this number.
// And keep backward compatible with the old version.
export const CURRENT_GAME_VERSION = 1;

// Default background image URL for interactive templates
export const DEFAULT_BACKGROUND_IMAGE_URL = "https://devprofjim.blob.core.windows.net/usermedia/27445478-0e26-46c8-a364-ae5be82e6010_352b9172-d049-4bfc-a847-9348a74f0cc3.png";
